import BaseField from "./BaseField";

export class CheckboxField extends BaseField {
    constructor(props) {
        super(props);

    }

    renderLabel(){
        let label = this.props.Label;
        if(this.props.Required){
            label += ' *';
        }
        return {
            __html: label
        }
    }

    render(){
        return (
            <div className={this.props.Columns}>
                <div className="field checkbox">
                    <input id={this.props.id} type="checkbox" className="checkbox" value={this.props.value} required={this.props.Required} onChange={(e) => {this.props.collectData(this.props.id, e.target.checked)}} />
                    <label className="smallLabel" htmlFor={this.props.id} dangerouslySetInnerHTML={this.renderLabel()}>
                    </label>
                    {this.renderErrorMessage()}
                </div>
            </div>
        )
    }

}
export default CheckboxField;
